/**
 * Utility function to format price display with "From" text based on price breakdowns
 * @param {Object} options - Configuration object
 * @param {string} options.currencySymbol - Currency symbol to display
 * @param {number} options.csprice - Custom special price
 * @param {Array} options.priceBreakdowns - Array of price breakdown objects with SpecialPrice property
 * @param {number} options.minProductPrice - Minimum product price fallback
 * @param {number} options.mainProductPrice - Main product price fallback
 * @param {number} options.gbpPriceBreakdown - GBP price breakdown indicator
 * @param {number} options.euroPriceBreakdown - Euro price breakdown indicator
 * @returns {string} Formatted price string with or without "From" text
 */
export const formatPriceWithBreakdown = ({
  currencySymbol,
  csprice,
  priceBreakdowns,
  minProductPrice,
  mainProductPrice,
  gbpPriceBreakdown,
  euroPriceBreakdown
}) => {
  // Check if there are price breakdowns to show "From" text
  const hasBreakdowns = (priceBreakdowns && priceBreakdowns.length > 0) || 
                        (gbpPriceBreakdown > 0) || 
                        (euroPriceBreakdown > 0);
  const fromText = hasBreakdowns ? 'From ' : '';
  
  // If there's a custom price (Csprice), use it
  if (csprice > 0) {
    return `${fromText}${currencySymbol}${csprice}`;
  }
  
  // If there are price breakdowns, find the minimum price
  // if (priceBreakdowns && priceBreakdowns.length > 0) {
  //   const minBreakdownPrice = Math.min(...priceBreakdowns.map(breakdown => breakdown.SpecialPrice));
  //   return `${fromText}${currencySymbol}${minBreakdownPrice}`;
  // }
  if (priceBreakdowns && priceBreakdowns.length > 0) {
    const minBreakdownPrice = Math.min(
      ...priceBreakdowns.map(breakdown => breakdown.SpecialPrice)
    );
    return `${fromText}${currencySymbol}${minBreakdownPrice.toFixed(2)}`;
  }

  
  // Fallback to existing logic (with "From" text if breakdown indicators exist)
  return `${fromText}${currencySymbol}${minProductPrice || mainProductPrice}`;
};
